var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonV3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12.5C14.3944 12.5 16.2112 11.8415 17.5508 10.6694C18.8903 9.49732 19.6429 7.9076 19.6429 6.25C19.6429 4.5924 18.8903 3.00269 17.5508 1.83058C16.2112 0.65848 14.3944 0 12.5 0C10.6056 0 8.78878 0.65848 7.44924 1.83058C6.10969 3.00269 5.35714 4.5924 5.35714 6.25C5.35714 7.9076 6.10969 9.49732 7.44924 10.6694C8.78878 11.8415 10.6056 12.5 12.5 12.5ZM9.94978 14.8438C4.45312 14.8438 0 18.7402 0 23.5498C0 24.3506 0.742188 25 1.65737 25H23.3426C24.2578 25 25 24.3506 25 23.5498C25 18.7402 20.5469 14.8438 15.0502 14.8438H9.94978Z",
    fill: "#fff",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonV3);
export default __webpack_public_path__ + "static/media/personV3.3eda9be0f24582fef76dcf920b4a53b2.svg";
export { ForwardRef as ReactComponent };